import { render } from "./TokenAuth.vue?vue&type=template&id=74c7adaa&scoped=true"
import script from "./TokenAuth.vue?vue&type=script&lang=js"
export * from "./TokenAuth.vue?vue&type=script&lang=js"

import "./TokenAuth.vue?vue&type=style&index=0&id=74c7adaa&lang=scss&scoped=true"
import "./TokenAuth.vue?vue&type=style&index=1&id=74c7adaa&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c7adaa"]])

export default __exports__